import React from "react";
import "./styles/modal.css";

import { IoMdClose } from "react-icons/io";

export default function Modal({
  isOpen,
  otherClassBarOptions,
  barOptionsComplements,
  otherClassModalInterface,
  title,
  onClose,
  id,
  otherClassModalContent,
  children,
}) {
  /* Condição que análisa a situação do modal (True ou false) e abre ou fecha ele. */
  if (isOpen) {
    return (
      /* Fundo escuro ou distorcido do modal. */
      <div
        className="background-modal"
        onClick={(event) => {
          if (event.target.classList.contains("background-modal")) onClose();
        }}
      >
        {/* Barra de opções para ser criada em cada modal */}
        <div className={`bar-options ${otherClassBarOptions}`}>
          {barOptionsComplements}
          <i className="bt-close" onClick={onClose} title="Fechar Janela">
            <IoMdClose />
          </i>
          {/* Botão de fechar o modal. */}
        </div>

        {/* Interface do modal. */}
        <div className={`modal-interface ${otherClassModalInterface}`}>
          <header className="header-modal">
            <h2>{title}</h2>
            {/* Titulo do Modal */}
          </header>

          {/* Container contendo as informações ou formulários do modal. */}
          <div className={`modal-content ${otherClassModalContent}`} id={id}>
            {children}
          </div>
        </div>
      </div>
    );
  }
  return null;
}
